/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
*/

require('./bootstrap');
/*
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;
const targetElement = document.querySelector("#mobile-form");*/


$(document).ready(function() {
  
  $('.menu-toggler').click(function() {
    $(this).find('a').toggleClass('btn-menu-open');
    $('#nav-mobil').toggleClass('open-menu');
    $('.header-contact').toggleClass('header-contact-open');
    $('body').toggleClass('no-scroll');
    $('.modal-backdrop').toggle();
  })
  
  $('.nav-item.dropdown').hover(function() {
          $(this).find('.dropdown-menu').stop(true, true).delay(0).fadeIn(200);
        }, function() {
          $(this).find('.dropdown-menu').stop(true, true).delay(0).fadeOut(200);
  })
  
  /*
  $('.home-nav .nav-item.dropdown').on('mouseenter', function() {
      $(this).find('.dropdown-toggle').attr('aria-expanded', true);
      $(this).find('.dropdown-menu').attr('aria-expanded', true).toggleClass('show');
  })
  $('.home-nav .nav-item.dropdown').on('mouseleave', function() {
      $(this).find('.dropdown-toggle').attr('aria-expanded', false);
      $(this).find('.dropdown-menu').attr('aria-expanded', false).toggleClass('show');
  })
  */
  
  // BANDEAU COOKIE OFFSET
  /*$(window).scroll(function(){
  	posScroll = $(document).scrollTop();
  	if(window.innerWidth < 575) {
    	if(posScroll >= 60) {
    	  $("#tarteaucitronAlertBig").css('top', 0);
    	}
    		
    	else {
    	  $("#tarteaucitronAlertBig").css('top', 60 - posScroll + 'px');
    	}
  	}
  });*/
  
  $('img[data-src$=".svg"]').each(function() {
      var $img = jQuery(this);
      var imgURL = $img.attr('data-src');
      var attributes = $img.prop("attributes");

      $.get(imgURL, function(data) {
          // Get the SVG tag, ignore the rest
          var $svg = jQuery(data).find('svg');

          // Remove any invalid XML tags
          $svg = $svg.removeAttr('xmlns:a');

          // Loop through IMG attributes and apply on SVG
          $.each(attributes, function() {
              $svg.attr(this.name, this.value);
          });

          // Replace IMG with SVG
          $img.replaceWith($svg);
      }, 'xml');
  });
  
  /// SCROLLto  
  $('.js-scrollTo').on('click', function() { 
        var page = $(this).attr('href'); 
        var speed = 750; 
        var offset = page == '#contact' ? 0 : 0;
        $('html, body').animate( { scrollTop: $(page).offset().top - 150}, speed ); 
        return false;
    });

  /// CONTACT US
  $('#form-modal').on('show.bs.modal', function (e) {
    $('html, body').animate({ scrollTop: $('body').offset().top}, 0); 
    $('body').toggleClass('form-open');
    $('#app').hide();
    $('footer').hide();
  });
  
  $('#form-modal').on('hide.bs.modal', function (e) {
    $('body').toggleClass('form-open');
    $('#app').show();
    $('footer').show();
  });

  
  $(window).scroll(function(){
  	posScroll = $(document).scrollTop();
  	if(posScroll >=60) {
  		$('.link_sticky').fadeIn(600);
  	  
  	}
  		
  	else {
  		$('.link_sticky').fadeOut(600);
  	  
  	}
  });

/// RETURN TOP
  
  //$('body').append('<a href="#header" class="top_link retour-top" title="Revenir en haut de page"></a>');
  $('.retour-top').click(function(e) {
    e.preventDefault();
    $('html, body').animate( { scrollTop: $('#top').offset().top}, 750 ); 
  })
  
  /*$(window).scroll(function(){
  	posScroll = $(document).scrollTop();
  	if(posScroll >=550) 
  		$('.top_link').fadeIn(600);
  	else
  		$('.top_link').fadeOut(600);
  });*/

	
    
    // CHECK AND SET COOKIES
  var cookies = checkCookie();
  if(cookies == true) {
    $('.alert-cookies').removeClass('d-flex');
    $('.alert-cookies').addClass('d-none');
    //$('alert-cookies').addClass('d-flex');
  }
  $('#accept-cookies').click(function(e) {
    if(!checkCookie()) {
      setCookie('accept-cookies', true, 1000);
      $('.alert-cookies').removeClass('d-flex');
      $('.alert-cookies').addClass('d-none');
    }
  });
  
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }
  
  function checkCookie() {
      var isAccepted = getCookie("accept-cookies");
      if (isAccepted != "") {
          return true;
      } else {
          return false;
      }
  }
});

/* Print page*/
$('.print').click(function(e) {
  e.preventDefault();
  e.stopPropagation();
  
  window.print();
})



// TOGGLE BACKDROP 
window.toggleBackdrop = function(status) {
    var body = document.querySelector('body');
    
    if(status) {
        body.classList.add('backdrop');
    }
    else {
        body.classList.remove('backdrop');
    }
    
}

// FIND COOKIE BY NAME
function getCookie(c_name) {
    var c_value = document.cookie,
        c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) c_start = c_value.indexOf(c_name + "=");
    if (c_start == -1) {
        c_value = null;
    } else {
        c_start = c_value.indexOf("=", c_start) + 1;
        var c_end = c_value.indexOf(";", c_start);
        if (c_end == -1) {
            c_end = c_value.length;
        }
        c_value = unescape(c_value.substring(c_start, c_end));
    }
    return c_value;
}

